<template lang="pug">
ul.nav
    li.nav-item.inline.dropdown(data-toggle="dropdown")
        a.btn.btn-default(data-toggle="dropdown") Export
        div.dropdown-menu.dropdown-menu-scale.pull-right
            span.dropdown-header Export As
            a.dropdown-item(@click="exportAsFile('CSV')") CSV
            a.dropdown-item(@click="exportAsFile('XLSX')") XLSX
            a.dropdown-item(@click="exportAsFile('PDF')") PDF
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import fileDownload from 'js-file-download';

export default {
    props: {
        chart: {
            type: String,
            required: true,
        },

        name: {
            type: String,
            required: true,
        },
    },

    computed: {
        ...mapGetters(['activeOutlet', 'startDate', 'endDate']),
        ...mapState('tillFilter', ['filters']),
    },

    methods: {
        exportAsFile(type) {
            const url = Laroute.route(
                'franchise.report.non_fuel.item.exportChartAsFile',
                {
                    type,
                },
            );

            let params = {
                chart: this.chart,
                outlet_id: this.activeOutlet,
                since: this.startDate.format(),
                until: this.endDate.format(),
                filters: this.filters,
            };

            this.$http({
                url: url,
                responseType: 'blob',
                method: 'post',
                headers: { Accept: 'multipart/form-data' },
                data: params,
            }).then(response => {
                fileDownload(
                    response.data,
                    `${this.name}.${type.toLowerCase()}`,
                );
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/item/export-chart.vue